import React, { useState } from 'react'
import { Formik, Form, ErrorMessage } from 'formik'
import axios from 'lib/axios'
import { Button, Col, Row, FormControl } from 'react-bootstrap'
import APISecretSchema from '../utilities/validation'

const generateKey = (length = 8) => {
  let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let str = '';
  for (let i = 0; i < length; i++) { str += chars.charAt(Math.floor(Math.random() * chars.length)) }

  return str;
}

const APISecretForm = ({ updateSecrets, toggleForm, updateAlert }) => {
  const [formState, updateForm] = useState({
    name: '',
    uid: `${generateKey(8)}-${generateKey(4)}-${generateKey(4)}-${generateKey(12)}`,
    secret: generateKey(32)
  })

  const submitForm = ({ event, formState }) => {
    event.preventDefault()

    APISecretSchema
      .validate(formState)
      .then(() => {
        axios.post('/api/authorization', formState)
          .then((response) => {
            updateSecrets(response.data.api_secret)
            updateAlert({ show: true, variant: 'success', text: 'API secret added.' })
            toggleForm(false)
          })
      })
      .catch((e) => { 'Formik handles errors and validations for us' })
  }

  return (
    <Formik initialValues={formState} onSubmit={submitForm} validationSchema={APISecretSchema}>
      <Form>
        <Row>
          <Col>
            <Row>
              <Col className='mb-1'>
                <label htmlFor="secrets-label">
                  What is this secret for?
                  <FormControl onChange={({ target }) => updateForm({ ...formState, name: target.value })} value={formState.name} id="secrets-label" />
                  <span style={{ color: 'red' }}>
                    <ErrorMessage name={'label'} />
                  </span>
                </label>
              </Col>
            </Row>

            <Row>
              <Col className='mb-1'>
                <label htmlFor="secrets-label">
                  Client ID: {formState.uid}
                  <span style={{ color: 'red' }}>
                    <ErrorMessage name={'uid'} />
                  </span>
                </label>
              </Col>
            </Row>

            <Row>
              <Col className='mb-1'>
                <label htmlFor="secrets-label">
                  Client Secret: {formState.secret}
                  <span style={{ color: 'red' }}>
                    <ErrorMessage name={'secret'} />
                  </span>
                </label>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button className='mr-1' onClick={(event) => submitForm({ event, formState })}>Add secret</Button>
            <Button variant="outline-secondary" onClick={() => toggleForm(false)}>Cancel</Button>
          </Col>
        </Row>
      </Form>
    </Formik>
  )
}

export default APISecretForm
